export const version = "web/5.8.0";
//# sourceMappingURL=_version.js.map